"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.selectPoint = void 0;
const three_1 = require("three");
const CSS2DRenderer_1 = require("three/examples/jsm/renderers/CSS2DRenderer");
const UiElements_1 = require("../../ui/UiElements");
const color_1 = require("./color");
function selectPoint(measureType, point, lineId) {
    const color = (0, color_1.selectColor)(measureType);
    const hexStringColor = colorToHexString(new three_1.Color(color));
    const div = createPoint(hexStringColor);
    const linePoint = new CSS2DRenderer_1.CSS2DObject(div.domEl);
    linePoint.position.copy(point);
    linePoint.name = "linePoint_" + lineId;
    return linePoint;
}
exports.selectPoint = selectPoint;
function createPoint(color) {
    return new UiElements_1.DivEl()
        .setClass('measurement-point')
        .setStyle({ 'background-color': color });
}
function colorToHexString(color) {
    return '#' + color.getHexString();
}
